@if (show) {
  <div class="audio-player" [class.hidden]="!shown" role="region" aria-label="Audio Player">
    <div class="d-flex">
      @if (showErrorMessage) {
        <div class="audio-player__error">
          <p>{{ "audio_player.error_message" | translate }}</p>
        </div>
      }
      <div class="audio-player__contents">
        <div class="audio-player__controls">
          @if (playlist.length > 0) {
            <button (click)="changeTrack('prev')" [attr.aria-label]="'audio_player.previous_audio' | translate">
              <fa-icon icon="chevron-left"></fa-icon>
            </button>
          }
          <button (click)="togglePlayback()" [attr.aria-label]="isPlaying ? ('pause' | translate) : ('play' | translate)" id="audio-player-play-button" tabindex="0">
            <fa-icon [icon]="isPlaying ? 'pause' : 'play'"></fa-icon>
          </button>
          <button (click)="close()" [attr.aria-label]="'stop' | translate" id="audio-player-play-button" tabindex="0">
            <fa-icon icon="stop"></fa-icon>
          </button>
          @if (playlist.length > 0) {
            <button (click)="changeTrack('next')" [attr.aria-label]="'audio_player.next_audio' | translate">
              <fa-icon icon="chevron-right"></fa-icon>
            </button>
          }
        </div>
        <div class="audio-player__timeline">
          @if (durationLoading) {
            <div class="audio-player__loading" aria-live="polite">Loading…</div>
          } @else {
            <div class="audio-player__timestring">{{ playbackPosition }}</div>
            <progress aria-labelledby="song_progress" class="audio-player__progress" [value]="progressValue" max="1" (click)="seek($event)"></progress>
            <div class="audio-player__timestring">{{ playbackDuration }}</div>
          }
        </div>
        <div class="audio-player__file">
          <p id="song_progress" class="audio-player__filename">{{ fileName }}</p>
          <div class="audio-player__file-controls">
            <button (click)="togglePlayback()" class="audio-player__mobile-play" [attr.aria-label]="isPlaying ? ('pause' | translate) : ('play' | translate)">
              <fa-icon [icon]="isPlaying ? 'pause' : 'play'"></fa-icon>
            </button>
            <button (click)="close()" class="audio-player__mobile-stop" [attr.aria-label]="'stop' | translate">
              <fa-icon icon="stop"></fa-icon>
            </button>
            @if (!hideDownloadOption) {
              <button (click)="downloadFile()" class="audio-player__download" [ngbTooltip]="'download.download' | translate" [attr.aria-label]="'audio_player.download_audio' | translate">
                <fa-icon icon="download"></fa-icon>
              </button>
            }
            @if (routeToSource) {
              <button (click)="goToSource()" class="audio-player__post-link" [ngbTooltip]="'audio_player.go_to_source' | translate" [attr.aria-label]="'audio_player.route_to_source' | translate">
                <fa-icon icon="arrow-up-right-from-square"></fa-icon>
              </button>
            }
            @if (playlist.length > 0) {
              <button (click)="togglePlaylist()" class="audio-player__playlist-toggle" [ngbTooltip]="'sphere.playlist' | translate" [attr.aria-label]="'audio_player.toggle_playlist' | translate">
                <fa-icon icon="bars"></fa-icon>
              </button>
            }
            <button (click)="shown = false" [ngbTooltip]="'sphere.minimize' | translate" [attr.aria-label]="'sphere.minimize' | translate" id="audio-player-close-mobile" tabindex="0">
              <fa-icon icon="compress"></fa-icon>
            </button>
          </div>
        </div>
        @if (audioLoaded) {
          <audio id="audio_player" autoplay="true">
            <source (error)="handleSourceError()" [src]="src" [type]="'audio/' + this.extension" />
          </audio>
        }
      </div>
    </div>
    @if (playlist.length > 0 && playlistOpen) {
      <div class="audio-player__list">
        <div class="audio-player__list-header">
          <p>{{ "playlist" | translate }}</p>
          <myp-switch [active]="autoplay" [label]="'autoplay' | translate" labelColor="#fff" (toggle)="toggleAutoplay()"></myp-switch>
        </div>
        <div class="audio-player__list-contents">
          @for (file of playlist; track file) {
            <div class="audio-player__list-item" [class.active]="file.id == currentFile.id">
              @if (file.id == currentFile.id && isPlaying) {
                <div class="audio-player__spinner">
                  <ngx-spinner name="waveform" color="#ed1c2e" bdColor="rgba(0,0,0,0)" [fullScreen]="false" type="line-scale-pulse-out" size="small"></ngx-spinner>
                </div>
              }
              <p (click)="play(file)">{{ file.filename }}</p>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
